import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-broadcast-renderer',
  templateUrl: './broadcast-renderer.component.html',
  styleUrls: ['./broadcast-renderer.component.css']
})
export class BroadcastRendererComponent implements ICellRendererAngularComp {

  params: any;
  label!: string;

  agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    this.params = params;
    return true;
  }

  onClick($event: any) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);
    }
  }
}
